const AJS_USER_ID_KEY = 'ajs_user_id';

export const getAjsUserId = (): string => {
  return localStorage.getItem(AJS_USER_ID_KEY) || '';
};
